//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular, {IHttpService, IPromise} from 'angular';

import * as bulkActionsApi from '@apis/bulkActionsApi';
import PartialCuid from '@models/PartialCuid';

export class BulkActionsApiService {
  // This is for backwards compatibility with legacy components, and should not be used.
  public updateLabelsAsync = bulkActionsApi.updateLabels;

  private BASE_URL: string;

  constructor(
        private $http: IHttpService,
        private promiseService,
        private sessionVarsService,
    ) {
    const webGatewayUrl = this.sessionVarsService.getBaseUrl('web_gateway');
    this.BASE_URL = `${webGatewayUrl}/api/v1`;
  }

  public addToLibraryAsync(cuids: PartialCuid[]): IPromise<any> {
    const params = {
      cuids,
    };

    return this.promiseService.processHttpResponse(
            this.$http.post(`${this.BASE_URL}/media/library`, params),
        );
  }

  public addToCollectionsAsync(cuids: PartialCuid[], collectionIds: string[]): IPromise<any> {
    const params = {
      collectionIds,
      cuids,
    };

    return this.promiseService.processHttpResponse(
            this.$http.post(`${this.BASE_URL}/media/collections`, params),
        );
  }

  public addToFanreelAsync(cuids: PartialCuid[], reelId: string): IPromise<any> {
    const params = {
      cuids,
    };

    return this.promiseService.processHttpResponse(
            this.$http.post(`${this.BASE_URL}/media/fanreel/${reelId}`, params),
        );
  }

  public removeFromLibraryAsync(cuids: PartialCuid[]): IPromise<any> {
    const params = {
      cuids,
    };

    return this.promiseService.processHttpResponse(
            this.$http.delete(
                `${this.BASE_URL}/media/library`,
              {
                data: params,
                headers: {
                  'content-type': 'application/json',
                },
              },
            ),
        );
  }

  public removeFromCollectionAsync(cuids: PartialCuid[], collectionId: string): IPromise<any> {
    const params = {
      cuids,
    };

    return this.promiseService.processHttpResponse(
            this.$http.delete(
                `${this.BASE_URL}/media/collection/${collectionId}`,
              {
                data: params,
                headers: {
                  'content-type': 'application/json',
                },
              },
            ),
        );
  }

  public registerDownloadAsync(cuids: PartialCuid[]): IPromise<any> {
    const params = {
      cuids,
    };

    return this.promiseService.processHttpResponse(
            this.$http.post(`${this.BASE_URL}/media/download`, params),
        );
  }

  public getRegisteredDownloadUrl(downloadToken: string): string {
    return `${this.BASE_URL}/media/download/${downloadToken}`;
  }
}

angular.module('curalate').service('BulkActionsApiService', [
  '$http',
  'PromiseService',
  'SessionVarsService',
  BulkActionsApiService,
]);
